import { generateColorFromString } from '@nexelem/utils';
import { useProductionPlanSettings } from '../../../components/SettingsDrawer';
import { NodeType, QueueBatchNode, QueueTaskNode } from '../../types';
import { ShadowParams } from '../NodeBase/StyledNodeBase';

// generate unique id for productName so batches with the same productName have the same color
const generateUniqueId = (node: QueueBatchNode): string =>
  node.tasks
    ?.map(({ productName }) => productName)
    .toSorted()
    .join(', ') || node.id.toString();

export const useNodeShadowParams = (node: QueueTaskNode | QueueBatchNode): ShadowParams | undefined => {
  const id = node.type === NodeType.BATCH ? generateUniqueId(node) : node.productName;
  const ganttProductColors = useProductionPlanSettings((state) => state.gantt.ganttProductColors);

  if (!ganttProductColors) {
    return undefined;
  }

  const color = generateColorFromString(id);

  return {
    color,
    isPreviousProductEqual: node.isPreviousProductEqual,
    isNextProductEqual: node.isNextProductEqual,
  };
};
